/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PostSearchDataItemPrice,
    PostSearchDataItemPriceFromJSON,
    PostSearchDataItemPriceFromJSONTyped,
    PostSearchDataItemPriceToJSON,
    PostSearchDataItemSegment,
    PostSearchDataItemSegmentFromJSON,
    PostSearchDataItemSegmentFromJSONTyped,
    PostSearchDataItemSegmentToJSON,
} from './';

/**
 * 
 * @export
 * @interface PostSearchDataItem
 */
export interface PostSearchDataItem {
    /**
     * 
     * @type {string}
     * @memberof PostSearchDataItem
     */
    flightId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostSearchDataItem
     */
    providerNames?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostSearchDataItem
     */
    route?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof PostSearchDataItem
     */
    totalFareAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PostSearchDataItem
     */
    totalTaxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PostSearchDataItem
     */
    totalPriceAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof PostSearchDataItem
     */
    currency?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PostSearchDataItem
     */
    excluded?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PostSearchDataItem
     */
    stepName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostSearchDataItem
     */
    ruleLink?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostSearchDataItem
     */
    ticketingCarriers?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostSearchDataItem
     */
    classes?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostSearchDataItem
     */
    fareTypes?: Array<string> | null;
    /**
     * 
     * @type {Date}
     * @memberof PostSearchDataItem
     */
    ttl?: Date;
    /**
     * 
     * @type {Array<PostSearchDataItemSegment>}
     * @memberof PostSearchDataItem
     */
    itinerary?: Array<PostSearchDataItemSegment> | null;
    /**
     * 
     * @type {Array<PostSearchDataItemPrice>}
     * @memberof PostSearchDataItem
     */
    pricing?: Array<PostSearchDataItemPrice> | null;
}

export function PostSearchDataItemFromJSON(json: any): PostSearchDataItem {
    return PostSearchDataItemFromJSONTyped(json, false);
}

export function PostSearchDataItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostSearchDataItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'flightId': !exists(json, 'flightId') ? undefined : json['flightId'],
        'providerNames': !exists(json, 'providerNames') ? undefined : json['providerNames'],
        'route': !exists(json, 'route') ? undefined : json['route'],
        'totalFareAmount': !exists(json, 'totalFareAmount') ? undefined : json['totalFareAmount'],
        'totalTaxAmount': !exists(json, 'totalTaxAmount') ? undefined : json['totalTaxAmount'],
        'totalPriceAmount': !exists(json, 'totalPriceAmount') ? undefined : json['totalPriceAmount'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'excluded': !exists(json, 'excluded') ? undefined : json['excluded'],
        'stepName': !exists(json, 'stepName') ? undefined : json['stepName'],
        'ruleLink': !exists(json, 'ruleLink') ? undefined : json['ruleLink'],
        'ticketingCarriers': !exists(json, 'ticketingCarriers') ? undefined : json['ticketingCarriers'],
        'classes': !exists(json, 'classes') ? undefined : json['classes'],
        'fareTypes': !exists(json, 'fareTypes') ? undefined : json['fareTypes'],
        'ttl': !exists(json, 'ttl') ? undefined : (new Date(json['ttl'])),
        'itinerary': !exists(json, 'itinerary') ? undefined : (json['itinerary'] === null ? null : (json['itinerary'] as Array<any>).map(PostSearchDataItemSegmentFromJSON)),
        'pricing': !exists(json, 'pricing') ? undefined : (json['pricing'] === null ? null : (json['pricing'] as Array<any>).map(PostSearchDataItemPriceFromJSON)),
    };
}

export function PostSearchDataItemToJSON(value?: PostSearchDataItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'flightId': value.flightId,
        'providerNames': value.providerNames,
        'route': value.route,
        'totalFareAmount': value.totalFareAmount,
        'totalTaxAmount': value.totalTaxAmount,
        'totalPriceAmount': value.totalPriceAmount,
        'currency': value.currency,
        'excluded': value.excluded,
        'stepName': value.stepName,
        'ruleLink': value.ruleLink,
        'ticketingCarriers': value.ticketingCarriers,
        'classes': value.classes,
        'fareTypes': value.fareTypes,
        'ttl': value.ttl === undefined ? undefined : (value.ttl.toISOString()),
        'itinerary': value.itinerary === undefined ? undefined : (value.itinerary === null ? null : (value.itinerary as Array<any>).map(PostSearchDataItemSegmentToJSON)),
        'pricing': value.pricing === undefined ? undefined : (value.pricing === null ? null : (value.pricing as Array<any>).map(PostSearchDataItemPriceToJSON)),
    };
}


